//Register page scripts
import {ServerApi} from "../api.js";
import {ErrorCode, handleFetchError, showNotice, YummyServerError} from "../helpers/functions.js";
import type {RegisterFormData} from "../../../../nodeserver/structs/database";

$('html').on('blur', 'input[name="username"]', async function () {
    const username = $(this).val() as string;
    if (username) {
        try {
            if (username.startsWith('id') && !isNaN(+username.substring(2))) {
                updateUserExists(true, 'Данный никнейм зарезервирован системой')
            } else {
                const userExists = await ServerApi.users.checkUserExists(username);
                updateUserExists(userExists, userExists ? "Никнейм " + escapeHtml(username) + " занят" : "Свободно")
            }

        } catch (e) {
            handleFetchError(e);
        }
    }
})
    .on('blur', '#check-email', function () {
        const text = $(this).val()! as string;
        $(this).val(
            text.replace('qmail.com', 'gmail.com')
                .replace('@mail.com', '@gmail.com')
                .replace('@gmail.cjm', '@gmail.com')
                .replace('@gmeil.com', '@gmail.com')
                .replace('@gmail.ccom', '@gmail.com')
                .replace('@gmail.cow', '@gmail.com')
                .replace('@gmail.ru', '@gmail.com')
                .replace('@gmail.om', '@gmail.com')
                .replace('@gamil.com', '@gmail.com')
                .replace('@gmmail.com', '@gmail.com')
                .replace('@ggmail.com', '@gmail.com')
                .replace('@gmail.c0m', '@gmail.com')
                .replace('@gnail.com', '@gmail.com')
                .replace('@googl.ru', '@gmail.com')
                .replace('@mail.rj', '@mail.ru')
                .replace('@mail.ry', '@mail.ru')
                .replace('@maill.ru', '@mail.ru')
                .replace('@mail.u', '@mail.ru')
                .replace('@mal.ru', '@mail.ru')
                .replace('@mai.ru', '@mail.ru')
                .replace('@mail.tu', '@mail.ru')
                .replace('@2mail.ru', '@mail.ru')
                .replace('@mil.ru', '@mail.ru')
                .replace('@dk.ru', '@bk.ru')
                .replace('@lisr.ru', '@list.ru')
                .replace('@ukr.ent', '@ukr.net')
                .replace('@gmail.con', '@gmail.com')
                .replace('@gmail.ry', '@gmail.com')
                .replace('@gmail.come', '@gmail.com')
                .replace('@gmail.comm', '@gmail.com')
                .replace('@gmail.cpm', '@gmail.com')
                .replace('@gmail.c0m', '@gmail.com')
                .replace('@gmail.comr', '@gmail.com')
                .replace('@yandex.ry', '@yandex.ru')
                .replace('@yandex.ok', '@yandex.ru')
                .replace('@online.ue', '@online.ua')
                .replace('@mail.rua', '@mail.ru')
                .replace('@gmail.cjv', '@gmail.com')
                .replace('@gmail.coom', '@gmail.com')
                .replace('@gmal.com', '@gmail.com')
                .replace('@gmale.com', '@gmail.com')
                .replace('@bk.r', '@bk.ru')
                .replace('@bk.ruu', '@bk.ru')
                .replace('@bk.ruuu', '@bk.ru')
                .replace('@mail.ruv', '@mail.ru')
                .replace('@gmail.vom', '@gmail.com')
                .replace('@gmial.com', '@gmail.com')
                .replace('@gmoil.com', '@gmail.com')
                .replace('@yandex.r', '@yandex.ru')
                .replace('@yandex.ri', '@yandex.ru')
                .replace('@yandex.ruu', '@yandex.ru')
                .replace('@gmail.ri', '@gmail.com')
                .replace('@gmail.com7', '@gmail.com')
                .replace('@ukr.ner', '@ukr.net')
                .replace('@gmail.cim', '@gmail.com')
                .replace('@inbox.tu', '@inbox.ru')
        );
    })
    .on('submit', '.register-form', async function (e) {
        if ($(this).hasClass('blocked')) return showNotice('Пожалуйста, подождите, запрос на регистрацию уже послан!');
        $(this).addClass('blocked');
        e.preventDefault();
        try {
            const values = getFormData.call(this);
            if (values.password !== values.password_repeat) {
                clearBoxes('password', 'password_repeat');
                return showNotice('Пароли не совпадают', 'Ошибка')
            }
            await ServerApi.profile.register(values);
            // try {
            //     // await ServerApi.video.updateAllWatches();
            // } catch (e) {
            //     console.error(e);
            // }
            showNotice('Для завершение регистрации, перейдите по ссылке, высланной вам на почту.', "Подтверждение почты", 'success');
            // window.location.href = `/users/id${user_id}`;
        } catch (e) {
            if (e instanceof YummyServerError) {
                if (e.code === ErrorCode.FormDataError) handleFormDataError(e);
                else if (e.code === ErrorCode.CaptchaError)
                    //@ts-ignore
                    grecaptcha.reset();
            }
            handleFetchError(e);
        } finally {
            $(this).removeClass('blocked');
        }
    })


function getFormData(this: HTMLFormElement): RegisterFormData {
    const data = $(this).serializeArray();
    const ans: RegisterFormData = {} as any;
    for (const el of data) ans[el.name as "email"] = el.value;
    return ans;
}

function updateUserExists(exists: boolean, message: string) {
    const $el = $('#result');
    if (!exists)
        $el.addClass('success-message').removeClass('error-message')
    else
        $el.addClass('error-message').removeClass('success-message');
    $el.html(message);
}

function clearBoxes(...names: string[]) {
    for (const inputName of names) {
        $(`input[name="${inputName}"]`).val('');
    }
}

function handleFormDataError(e: YummyServerError) {

    switch (e.subErrorCode) {
        case 1:
            clearBoxes('email');
            break;
        case 2:
            clearBoxes('password', 'password_repeat');
            break;
        case 3:
            clearBoxes('username');
            break;
        default:
            console.warn(`Unknown error: ${e}`)
    }
    //@ts-ignore
    grecaptcha.reset();
}